export type MandatorySignupFields = {
  firstName: string;
  lastName: string;
  companyName: string;
  phone: string;
  email?: string;
  password?: string;
  confirmPassword?: string;
};

const REQUIRED_FIELD_LABELS: Record<keyof MandatorySignupFields, string> = {
  firstName: 'first name',
  lastName: 'last name',
  companyName: 'company name',
  phone: 'phone/WhatsApp',
  email: 'email address',
  password: 'password',
  confirmPassword: 'confirm password',
};

const REQUIRED_PROFILE_FIELDS: Array<keyof MandatorySignupFields> = ['firstName', 'lastName', 'companyName', 'phone'];
const REQUIRED_CREDENTIAL_FIELDS: Array<keyof MandatorySignupFields> = ['email', 'password', 'confirmPassword'];

export const getMissingMandatorySignupFields = (
  fields: MandatorySignupFields,
  options: { includeCredentials?: boolean } = {},
): string[] => {
  const requiredFields = options.includeCredentials
    ? [...REQUIRED_PROFILE_FIELDS, ...REQUIRED_CREDENTIAL_FIELDS]
    : REQUIRED_PROFILE_FIELDS;

  return requiredFields.filter((field) => !String(fields[field] ?? '').trim());
};

export const getMandatorySignupFieldsError = (missingFields: string[]): string | null => {
  if (missingFields.length === 0) return null;

  const labels = missingFields.map((field) => REQUIRED_FIELD_LABELS[field as keyof MandatorySignupFields] ?? field);
  return `Please enter your ${labels.join(', ')} before signing up.`;
};
